import React from "react";

import { Link } from "react-router-dom";

const columns = (updateRole = false) => {
  let returnArray = [
    {
      text: "Name",
      dataField: "name",
    },
    {
      text: "Voids Inspection",
      dataField: "voids_inspection",
      formatter: (cell) => (cell ? "Yes" : "No"),
    },
    {
      text: "Default",
      dataField: "default",
      formatter: (cell) => (cell ? "Yes" : "No"),
    },
  ];

  if (updateRole) {
    returnArray.push({
      text: "Edit",
      dataField: "edit",
      csvExport: false,
      formatter: (cell, row) => <Link to={`/project/qa/welding_inspections/surface_conditions/${row.id}/edit`}>Edit</Link>,
    });
  }

  return returnArray;
};

export default columns;
